import { render, staticRenderFns } from "./ProductWarranties.vue?vue&type=template&id=6cb77b3d&"
import script from "./ProductWarranties.vue?vue&type=script&lang=js&"
export * from "./ProductWarranties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports